/**
 * Redux actions for Call Management & UX feature.
 */
import { queueService } from '../interpreter-queue/InterpreterQueueService';
import { forgetCallWaitingAnswer, rememberCallWaitingAnswer } from './callWaitingSwitch';
import { CALL_WAITING_INCOMING, CALL_WAITING_RESPONDED, CALL_WAITING_DISMISS, HELD_CALL_CLEARED, HELD_CALL_SET, INCOMING_P2P_CALL, INCOMING_P2P_CLEAR, CALL_HOLD_UPDATED, CALL_ON_HOLD, CALL_OFF_HOLD, CONFERENCE_INVITE, CONFERENCE_ADD_RINGING, CONFERENCE_PARTICIPANT_REMOVED, CHAT_MESSAGE_RECEIVED, CHAT_MESSAGE_SENT, CHAT_HISTORY_LOADED, CHAT_PANEL_TOGGLE, PREFERENCES_UPDATED, DND_TOGGLED, DARK_MODE_CHANGED, P2P_TARGET_DND } from './actionTypes';
// ---- Call Waiting ----
export const callWaitingIncoming = (data) => ({
    type: CALL_WAITING_INCOMING,
    data
});
/**
 * Answer a call that rang during this one (callWaitingSwitch.ts): the answer
 * is remembered so its p2p_join_room ends or holds the current call, then
 * sent (buffered until the socket is signed in). Throws when it cannot be
 * sent at all.
 */
export const callWaitingRespond = (incomingCallId, currentCallId, action) => {
    rememberCallWaitingAnswer({ action, currentCallId, incomingCallId });
    try {
        queueService.respondToCallWaiting({ action, currentCallId, incomingCallId });
    }
    catch (error) {
        forgetCallWaitingAnswer(incomingCallId);
        throw error;
    }
    return { type: CALL_WAITING_RESPONDED, data: { incomingCallId, action } };
};
export const heldCallSet = (heldCall) => ({
    type: HELD_CALL_SET,
    heldCall
});
export const heldCallCleared = (callId) => ({
    type: HELD_CALL_CLEARED,
    callId
});
export const incomingP2PCall = (data) => ({
    type: INCOMING_P2P_CALL,
    data
});
export const clearIncomingP2PCall = () => ({
    type: INCOMING_P2P_CLEAR
});
export const callWaitingDismiss = () => ({
    type: CALL_WAITING_DISMISS
});
// ---- Call Hold ----
export const toggleCallHold = (callId, onHold) => {
    queueService?.send({
        type: 'call_hold',
        data: { callId, onHold }
    });
    return { type: CALL_HOLD_UPDATED, data: { callId, onHold } };
};
export const callOnHold = (data) => ({
    type: CALL_ON_HOLD,
    data
});
export const callOffHold = (data) => ({
    type: CALL_OFF_HOLD,
    data
});
// ---- Conference (3-way) ----
export const addConferenceParticipant = (callId, phoneNumber, clientId) => {
    queueService?.send({
        type: 'conference_add',
        data: { callId, phoneNumber, clientId }
    });
    return { type: CONFERENCE_ADD_RINGING, data: { callId } };
};
export const removeConferenceParticipant = (callId, participantId) => {
    queueService?.send({
        type: 'conference_remove',
        data: { callId, participantId }
    });
    return { type: CONFERENCE_PARTICIPANT_REMOVED, data: { callId, participantId } };
};
export const conferenceInvite = (data) => ({
    type: CONFERENCE_INVITE,
    data
});
// ---- In-call Chat ----
export const sendChatMessage = (callId, message) => {
    queueService?.send({
        type: 'chat_send',
        data: { callId, message }
    });
    return { type: CHAT_MESSAGE_SENT, data: { callId, message } };
};
export const requestChatHistory = (callId, limit = 100, offset = 0) => {
    queueService?.send({
        type: 'chat_history',
        data: { callId, limit, offset }
    });
    return { type: CHAT_HISTORY_LOADED, data: { callId, messages: [] } };
};
export const chatMessageReceived = (data) => ({
    type: CHAT_MESSAGE_RECEIVED,
    data
});
export const chatHistoryLoaded = (data) => ({
    type: CHAT_HISTORY_LOADED,
    data
});
export const toggleChatPanel = () => ({
    type: CHAT_PANEL_TOGGLE
});
// ---- Client Preferences ----
export const preferencesUpdated = (data) => ({
    type: PREFERENCES_UPDATED,
    data
});
export const toggleDND = (enabled, message) => {
    queueService?.send({
        type: 'preferences_update',
        data: { dnd_enabled: enabled, dnd_message: message || '' }
    });
    return { type: DND_TOGGLED, data: { enabled, message } };
};
export const setDarkMode = (mode) => {
    queueService?.send({
        type: 'preferences_update',
        data: { dark_mode: mode }
    });
    return { type: DARK_MODE_CHANGED, data: { mode } };
};
// ---- P2P Target DND ----
export const p2pTargetDnd = (data) => ({
    type: P2P_TARGET_DND,
    data
});
